import { Pipe, PipeTransform } from '@angular/core';
import { ArticleInterface } from '../interfaces';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheStorageService } from '../services';
import { ActivatedRoute } from '@angular/router';



@Pipe({
    name: 'setImage'
})

export class SetImagePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer,
        private route: ActivatedRoute
    ) { }

    async transform(articles: Array<ArticleInterface>): Promise<Array<ArticleInterface>> {
        const categoryId = this.route.snapshot.paramMap.get('categoryId') || 1;
        console.log(categoryId)
        const defaultImage = '/assets/images/' + categoryId + '.svg'

        for (const article of articles) {
            const data = await CacheStorageService.getCache('articleImage', <string>'https://py-volg-prod-e474d0631bf9.herokuapp.com/static/images/articles/' + article.id + '.png');
            if (data) {
                article.image = this.domSanitizer.bypassSecurityTrustUrl(data);
            } else {
                const imageUrl = 'https://py-volg-prod-e474d0631bf9.herokuapp.com/static/images/articles/' + article.id + '.png';
                const validImage = await this.isImageAvailable(imageUrl);
                if (validImage) {
                    article.image = imageUrl
                    await CacheStorageService.setCache('articleImage', 'https://py-volg-prod-e474d0631bf9.herokuapp.com/static/images/articles/' + article.id + '.png');
                } else {
                    article.image = defaultImage;
                }
            }
        };
        return articles;
    }

    private async isImageAvailable(url: string): Promise<boolean> {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok; // Returns true if the image exists
        } catch {
            return false; // Assume failure if the fetch fails
        }
    }
}
